import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusBarComponent } from './status-bar.component';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';

@NgModule({
  declarations: [StatusBarComponent],
  imports: [
    CommonModule,
    IonicModule,
    RouterLink,
  ],
  exports: [StatusBarComponent],
})
export class StatusModule {}
